import "./errorsForm.css"

export const renderLoginErrorMsg = (loginErrorMsg) => {
  if (loginErrorMsg !== undefined) {
    return <p className='error-message'>{loginErrorMsg}</p>
  }
}
export default renderLoginErrorMsg

export const renderErrorMsg = (formErrorMsg, field) => {
  if (formErrorMsg?.[field] !== undefined) {
    return <p className='error-message'>{formErrorMsg?.[field]}</p>
  }
}
